import { clsx } from 'clsx';
import { Typography } from '@material-ui/core';

import { OrderTypeChip } from 'components/order-type-chip';
import { TurboTag } from '../../../features/order/geoqueues/components';
import { AuditableChip } from 'components/main-kanban-card/components';
import { SubstitutionFlowStatusChip } from 'features/order/substitution-flow';

import { formatCurrency } from '../../../utils/CurrencyUtils';

import { SUBSTITUTION_FLOW_STATUS_MAP } from 'shared/infra';

import makeClasses from './CustomActionKanbanCard.styles';

export default function CustomActionKanbanCard(props) {
  const {
    onClick,
    storeName,
    orderID,
    order = {},
    totalPrice,
    showChipOfBundle = false,
    showAuditableChip = false,
    classes: externalClasses = {},
    isTurboqueue = false,
  } = props;

  const showStoreName = Boolean(storeName);
  const showTotalPrice = Boolean(totalPrice);

  const classes = makeClasses();

  return (
    <article
      onClick={onClick}
      data-has-turbotag={isTurboqueue}
      data-has-substitution-flow={!!order?.substitution_flow_state}
      className={clsx(classes.article, externalClasses?.root)}
    >
      {isTurboqueue && <TurboTag parentClass={classes.turboTag} />}
      <section className={classes.section}>
        <header>
          <SubstitutionFlowStatusChip
            size='small'
            status={
              SUBSTITUTION_FLOW_STATUS_MAP[
                order?.substitution_flow_state?.status ?? ''
              ]
            }
            deletedAt={
              new Date(order?.substitution_flow_state?.deleted_at ?? '')
            }
          />
          <OrderTypeChip orderType={showChipOfBundle ? 'bundle' : 'normal'} />
          <AuditableChip show={showAuditableChip} />
        </header>
        <main>
          <Typography component='h5' variant='body1' className={classes.oId}>
            ID: {orderID}
          </Typography>
        </main>
        {(showStoreName || showTotalPrice) && (
          <footer>
            {showStoreName && (
              <Typography className={classes.storeName} variant='overline'>
                {storeName}
              </Typography>
            )}
            {showTotalPrice && (
              <Typography variant='subtitle2'>
                {formatCurrency(totalPrice, true)}
              </Typography>
            )}
          </footer>
        )}
      </section>
    </article>
  );
}
